/**
 * AddUserFormHook
 *
 * Handles form submission for the SmartUserDropdown "Add New User" modal.
 * Gathers form input values and pushes them to the LiveView for validation and saving.
 * This avoids nested form issues since the modal is rendered inside a parent form.
 */
export default {
  mounted() {
    console.log('AddUserFormHook: mounted', this.el.id);
    
    const dropdownId = this.el.dataset.dropdownId;
    const roleType = this.el.dataset.roleType;
    const target = this.el.dataset.target;
    
    console.log('AddUserFormHook: dropdownId=', dropdownId, 'roleType=', roleType, 'target=', target);
    
    // Submit button is now a sibling of the hooked div, look in parent
    const submitButton = document.getElementById(`${dropdownId}-submit-btn`);
    
    if (!submitButton) {
      console.error('AddUserFormHook: Submit button not found for id:', `${dropdownId}-submit-btn`);
      return;
    }

    console.log('AddUserFormHook: Found submit button', submitButton);

    // Store original button HTML for reset
    const originalButtonHTML = submitButton.innerHTML;

    // Debounce helper for change events
    let debounceTimer = null;
    const debounce = (fn, delay = 300) => {
      return (...args) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fn(...args), delay);
      };
    };

    // Gather all form values from inputs inside the hooked element
    const gatherFormValues = () => {
      const inputs = this.el.querySelectorAll('input');
      const values = {};
      
      inputs.forEach(input => {
        // Extract field name from input name (e.g., "new_user[first_name]" -> "first_name")
        const match = input.name.match(/\[([^\]]+)\]$/);
        if (match) {
          values[match[1]] = input.value;
        }
      });
      
      console.log('AddUserFormHook: gathered values', values);
      return values;
    };

    // Handle input changes for validation
    const handleChange = debounce(() => {
      const values = gatherFormValues();
      
      const params = {
        "dropdown-id": dropdownId,
        "new_user": values
      };

      console.log('AddUserFormHook: pushing validate_add_user', params);
      
      if (target && target.length > 0) {
        this.pushEventTo(target, 'validate_add_user', params);
      } else {
        this.pushEvent('validate_add_user', params);
      }
    });

    // Add change listeners to all inputs
    const inputs = this.el.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('input', handleChange);
      input.addEventListener('blur', handleChange);
    });

    // Handle submit button click
    const handleSubmit = (e) => {
      console.log('AddUserFormHook: submit button clicked');
      e.preventDefault();
      e.stopPropagation();
      
      // Disable button while submitting
      submitButton.disabled = true;
      submitButton.textContent = 'Creating...';
      
      const values = gatherFormValues();
      
      const params = {
        "dropdown-id": dropdownId,
        "role_type": roleType,
        "new_user": values
      };

      console.log('AddUserFormHook: pushing save_add_user', params);
      
      if (target && target.length > 0) {
        this.pushEventTo(target, 'save_add_user', params);
      } else {
        this.pushEvent('save_add_user', params);
      }
    };
    
    submitButton.addEventListener('click', handleSubmit);

    // Store references for cleanup
    this.submitButton = submitButton;
    this.handleSubmit = handleSubmit;
    this.originalButtonHTML = originalButtonHTML;
    
    // Store cleanup function
    this.cleanup = () => {
      clearTimeout(debounceTimer);
      inputs.forEach(input => {
        input.removeEventListener('input', handleChange);
        input.removeEventListener('blur', handleChange);
      });
      if (this.submitButton) {
        this.submitButton.removeEventListener('click', this.handleSubmit);
      }
    };
  },

  // When LiveView updates the DOM (e.g., after validation error), reset button state
  updated() {
    console.log('AddUserFormHook: updated');
    if (this.submitButton && this.submitButton.disabled) {
      this.submitButton.disabled = false;
      this.submitButton.innerHTML = this.originalButtonHTML;
    }
  },

  destroyed() {
    console.log('AddUserFormHook: destroyed');
    if (this.cleanup) {
      this.cleanup();
    }
  }
};

